import React from 'react';
import { STATUS_META } from './recoveryUi';

export default function StatusChip({ status, testId }) {
  const m = STATUS_META[status] || STATUS_META.draft;
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10.5px] font-bold border whitespace-nowrap"
          style={{ background: m.bg, color: m.fg, borderColor: m.bd }} data-testid={testId}>
      {m.label}
    </span>
  );
}
